import { render } from "./Jumbotron.vue?vue&type=template&id=3073db59&scoped=true&ts=true"
import script from "./Jumbotron.vue?vue&type=script&lang=ts"
export * from "./Jumbotron.vue?vue&type=script&lang=ts"

import "./Jumbotron.vue?vue&type=style&index=0&id=3073db59&lang=scss"
import "./Jumbotron.vue?vue&type=style&index=1&id=3073db59&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3073db59"]])

export default __exports__